export const LOCALIZATION_FORMATTERS = {
  possessive: {
    en: (v: string) => `${v}'s`,
  },
};
